import autoScroll from "dom-autoscroller";
import {ref} from "vue";

const scrollContainer = ref(null);
let scroller = null;
const drag = ref(false);

export function useDraggerEvents() {
    function startDrag() {
        drag.value = true;
        scroller = autoScroll(scrollContainer.value, {
            margin: 20, maxSpeed: 10, scrollWhenOutside: true, autoScroll: function () {
                // Only scroll when the pointer is down, and there is a child being dragged.
                return this.down && this.pointerHovered;
            }
        });
    }

    function endDrag() {
        drag.value = false;
        if (scroller) {
            scroller.destroy();
            scroller = null;
        }
    }

    return {
        startDrag, endDrag, scrollContainer, scroller, drag
    }
}